import { Routes } from '@angular/router';
import { hasAccessGuard } from './guards/has-access.guard';

export const routes: Routes = [
  {
    path: '',
    title: 'Accueil',
    canActivate: [hasAccessGuard],
    loadComponent: () => import('./pages/home/home').then(m => m.Home),
  },
  {
    path: 'school-organization',
    title: 'Organisation école',
    canActivate: [hasAccessGuard],
    loadChildren: () =>
      import('./pages/school-organization/school-organization.routes').then(m => m.schoolOrganizationRoutes),
  },
  {
    path: 'grid-templates',
    title: 'Modèles de grille',
    canActivate: [hasAccessGuard],
    loadChildren: () =>
      import('./pages/grid-template-management/grid-template-management.routes').then(m => m.gridTemplateManagementRoutes),
  },
  {
    path: 'apply-grid',
    title: 'Grilles horaires',
    canActivate: [hasAccessGuard],
    loadChildren: () =>
      import('./pages/apply-grid-management/apply-grid-management.routes').then(m => m.applyGridManagementRoutes),
  },

  {
    path: 'grid',
    title: 'Grilles horaires',
    canActivate: [hasAccessGuard],
    loadChildren: () =>
      import('./pages/administrative-grid/grid-consultation/grid-consultation.routes').then(m => m.gridConsultationRoutes),
  },
  {
    path: 'no-access',
    title: 'Aucun accès',
    loadComponent: () => import('./pages/no-access/no-access').then(m => m.NoAccess),
  },
];
